import {
  CD_FULL_DAY_HEIGHT,
  CD_TIME_LINE_HEIGHT,
} from '@app/components/Calendars/components/Dashboard/constants';
import { FullDayTasks } from '@app/components/Calendars/components/TimeColumn/components/FullDayTasks';
import type { TimeColumnType } from '@app/components/Calendars/components/TimeColumn/types';

import '@app/components/Calendars/components/TimeColumn/styles/TimeColumn.desktop.scss';

export const TimeColumn: TimeColumnType = ({
  times,
  tasks: { day, fullDayTasks, dailyTaskList },
  createTaskForRange,
  openPreviewTaskModal,
}) => {
  return (
    <div className="time-column-container">
      <FullDayTasks
        tasks={fullDayTasks}
        openPreviewTaskModal={openPreviewTaskModal}
      />
      <div className="time-column-grid">
        {times.map((time, index) => {
          const nextDate = times[index + 1] || times[0];
          const timeRange = `${time} - ${nextDate}`;
          return (
            <div
              key={time}
              style={{ height: CD_TIME_LINE_HEIGHT }}
              className="time-column-grid-line"
              onClick={() => createTaskForRange([time, nextDate], day)}
            >
              <div className="new-task-hover">{timeRange} - Создать задачу</div>
            </div>
          );
        })}
      </div>
      {dailyTaskList.map(({ top, height, left, title, id, status }) => (
        <div
          key={id}
          className="task dayly-task"
          data-status={status}
          style={{
            height,
            left,
            top: top + CD_FULL_DAY_HEIGHT,
          }}
          onClick={() => openPreviewTaskModal(+id)}
        >
          {title}
        </div>
      ))}
    </div>
  );
};
